import css from './news-tags-filter.module.scss';
import classNames from 'classnames';
import { TagView } from 'src/types';

interface NewsTagsFilterProps {
  tags: TagView[];
  onClick: (tag: TagView) => void;
  selectedTags: string[];
}

export default function NewsTagsFilter({ tags, onClick, selectedTags }: Readonly<NewsTagsFilterProps>) {
  if (tags.length === 0) {
    return null;
  }

  return (
    <div className={css.filterTags}>
      <p className={css.title}>Фільтрація за тегами</p>
      <div className={css.tags}>
        {tags.map((tag) => (
          <button
            key={tag.id}
            onClick={() => onClick(tag)}
            className={classNames(css.tag, selectedTags.includes(tag.id) ? css.active : '')}>
            {tag.name}
          </button>
        ))}
      </div>
    </div>
  );
}
